import { useCallback, useState } from "react";
import axios from "axios";
import config from "../../../config";

const EMPTY_CHARTS = { data: [] };

const useExitChartData = () => {
  const [chartsData, setChartsData] = useState(EMPTY_CHARTS);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchExitChartData = useCallback(({ approachId, from, to }) => {
    setLoading(true);
    setError(null);
    return axios
      .get(`${config.FLYOVER_RCM_API_URL}/exit/data/chart/${approachId}`, {
        headers: { "X-API-Key": config.FLYOVER_RCM_API_TOKEN },
        params: { from, to },
      })
      .then((res) => {
        setChartsData({ data: res.data?.data ?? [] });
      })
      .catch((err) => {
        console.error("useExitChartData: fetch failed", err);
        setChartsData(EMPTY_CHARTS);
        setError(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return { chartsData, loading, error, fetchExitChartData };
};

export default useExitChartData;
